import script from "./CheckoutFooterMain.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckoutFooterMain.vue?vue&type=script&lang=ts&setup=true"

import "./CheckoutFooterMain.vue?vue&type=style&index=0&id=0b8ea110&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b8ea110"]])

export default __exports__